<!-- For Web -->
@if (!utilService.isOnlyMobile()) {
  <ul class="m-0 pagination pull-right pl-2">
    <!-- <li class="page-item" [class.disabled]="currentPage === 1" (click)="onPageClick(1)">
    <a class="page-link">
      <span aria-hidden="true">&laquo;</span>
    </a>
  </li> -->
  <li class="page-item" [class.disabled]="currentPage === 1" (click)="onPageClick(currentPage - 1)">
    <a class="page-link">
      <!-- <span aria-hidden="true">&lt;</span> -->
      <i class="fa fa-angle-left" aria-hidden="true"></i>
    </a>
  </li>
  <!-- <span class="result-per-page" *ngIf="itemsCount">{{(currentPage - 1) * limit + 1}}-{{currentPage * limit
  < itemsCount ? currentPage * limit : itemsCount}} / {{itemsCount}}
</span> -->
@if (config.showCount != -1) {
  @if (itemsCount) {
    <a class="result-per-page" href="javascript:void(0);" [triggered]="showPages"
      (click)="showById('paginationCount')" (clickOutside)="showId('paginationCount')">
      {{(currentPage - 1) * limit + 1}}-{{currentPage * limit
    < itemsCount ? currentPage * limit : itemsCount}} / {{itemsCount}} </a>
  }
}
@if (config.showCount == -1) {
  @if (gridConfig.currentItemCount != 0) {
    <a class="result-per-page" href="javascript:void(0);" [triggered]="showPages"
      (click)="showById('paginationCount')" (clickOutside)="showId('paginationCount')">
      {{(currentPage - 1) * limit + 1}}-{{gridConfig.currentItemCount < limit ? (currentPage - 1) * limit +
      gridConfig.currentItemCount : currentPage * limit}}{{gridConfig.currentItemCount < limit ? " of "
    +((currentPage - 1) * limit + gridConfig.currentItemCount) :""}} </a>
  }
  @if (gridConfig.currentItemCount == 0) {
    {{"field.label.no_records_found" | translate | async}}
  }
}
@if (showPages) {
  <div class="dropdown-menu paginationCount show" id="paginationCount" aria-labelledby="paginationCount"
    >
    @for (pLimit of pageLimit; track pLimit) {
      <span class="dropdown-item" (click)="limitChange($event,pLimit)">{{pLimit}} in
      a page</span>
    }
  </div>
}
@if (config.showCount != -1) {
  <li class="page-item" [class.disabled]="currentPage === pageCount" (click)="onPageClick(currentPage + 1)">
    <a class="page-link">
      <!-- <span aria-hidden="true">&gt;</span> -->
      <i class="fa fa-angle-right" aria-hidden="true"></i>
    </a>
  </li>
}
@if (config.showCount == -1) {
  <li class="page-item" [class.disabled]="gridConfig.currentItemCount < limit"
    (click)="onPageClick(currentPage + 1)">
    <a class="page-link">
      <!-- <span aria-hidden="true">&gt;</span> -->
      <i class="fa fa-angle-right" aria-hidden="true"></i>
    </a>
  </li>
}
@if (!config.hidegetCount) {
  @if (config.showCount == -1 && gridConfig.currentItemCount != 0 && !(gridConfig.currentItemCount < limit)) {
    <a class="get-count-link-button" (click)="getCount()" href="javascript:void(0);" title="Get Count">
      <button type="button" class="btn-with-img-icon-label">
        <img src="assets/images/icons/get-count-icon.svg">
        <span>{{"# Count" | translate | async}}</span>
      </button>
    </a>
  }
}
</ul>
}

<!-- For Mobile -->
@if (utilService.isOnlyMobile()) {
  <div class="_mobile-pagination-content">
    <div class="_previous-button-container" [class.disabled]="currentPage === 1" (click)="onPageClick(currentPage - 1)">
      <i class="fa fa-angle-left pr-2"></i>Previous</div>
      @if (config.showCount != -1) {
        @if (itemsCount!=undefined && itemsCount && config!=undefined && config.totalPages!=undefined) {
          <div class="_mobile-pagination-count bottom 1"
            >
            <span class=""> {{(currentPage - 1) * limit + 1}}-{{currentPage * limit
            < itemsCount ? currentPage * limit : itemsCount}} / {{itemsCount}}</span>
          </div>
        }
      }
      @if (config.showCount == -1) {
        @if (gridConfig.currentItemCount != 0) {
          <div class="_mobile-pagination-count bottom 2">
            <span class="">
              {{(currentPage - 1) * limit + 1}}-{{gridConfig.currentItemCount < limit ? (currentPage - 1) * limit
              + gridConfig.currentItemCount : currentPage * limit}} {{gridConfig.currentItemCount < limit
            ? " of " +((currentPage - 1) * limit + gridConfig.currentItemCount) : "" }} </span>
            @if (config.showCount == -1 && gridConfig.currentItemCount != 0 && !(gridConfig.currentItemCount < limit)) {
              <a class="get-count-link-button" (click)="getCount()" href="javascript:void(0);"
                title="Get Count">
                <button type="button" class="btn-with-img-icon-label">
                  <!-- <img src="assets/images/icons/get-count-icon.svg"> -->
                  <span class="mobile-pagination-pipe">|</span>
                  <span class="mobile-count-link">{{"# Count" | translate | async}}</span>
                </button>
              </a>
            }
          </div>
        }
        @if (gridConfig.currentItemCount == 0) {
          <span class="">
            {{"field.label.no_records_found" | translate | async}}
          </span>
        }
        <!-- <ng-container *ngIf="config.showCount == -1 && gridConfig.currentItemCount != 0 && !(gridConfig.currentItemCount < limit)">
        <a class="result-per-page" (click)="getCount()" href="javascript:void(0);" title="Get Count"> <i class="fa fa-sum" aria-hidden="true"></i></a>
      </ng-container> -->
    }
    <div class="_next-button-container" [class.disabled]="gridConfig.currentItemCount < limit"
      (click)="onPageClick(currentPage + 1)">Next<i class="fa fa-angle-right pl-2"></i></div>
    </div>
  }


  <!-- <span class="result-per-page pull-right pt-2" *ngIf="itemsCount">{{(currentPage - 1) * limit + 1}}-{{currentPage * limit
  < itemsCount ? currentPage * limit : itemsCount}} of {{itemsCount}}
  records
</span> -->
<!-- <span class="result-per-page pull-right pt-2" *ngIf="!itemsCount">0 records</span> -->